import { Context } from './_context';
import { useHooks } from './_hook';
import { AuthProviderProps } from './_types';

/**
 * Authentication Provider - view
 */
export default function (props: AuthProviderProps) {
  const context = useHooks(props);

  if (context.loading) {
    return;
  }

  return <Context.Provider value={context}>{props.children}</Context.Provider>;
}
